import {isNil, isNotNil} from 'ramda';

import {CarPassMileageIssueCode, CarPassRequestIssues} from '@dms/api/vehicle';

export const DEFAULT_CAR_PASS_MILEAGE_ISSUE_KEY = 'page.carPass.actionRequiredIssue.default';

const MILEAGE_ISSUE_KEY_BY_CODE = new Map<number, string>([
  [
    CarPassMileageIssueCode.MILEAGE_LOWER_THAN_PREVIOUS,
    'page.carPass.actionRequiredIssue.mileageLowerThanPrevious',
  ],
  [CarPassMileageIssueCode.INVALID_MILEAGE, 'page.carPass.actionRequiredIssue.invalidMileage'],
  [
    CarPassMileageIssueCode.MILEAGE_NOT_REPORTED_IN_TIME,
    'page.carPass.actionRequiredIssue.mileageNotReportedInTime',
  ],
  [
    CarPassMileageIssueCode.MILEAGE_HAS_MORE_DIGITS_THAN_ODOMETER,
    'page.carPass.actionRequiredIssue.mileageHasMoreDigitsThanOdometer',
  ],
  [
    CarPassMileageIssueCode.MILEAGE_IS_ROUNDED_NUMBER,
    'page.carPass.actionRequiredIssue.mileageIsRoundedNumber',
  ],
  [
    CarPassMileageIssueCode.MILEAGE_HIGHER_THAN_EXPECTED,
    'page.carPass.actionRequiredIssue.mileageHigherThanExpected',
  ],
]);

export function getCarPassMileageIssueKeys(issues: CarPassRequestIssues | null): string[] {
  if (isNil(issues)) {
    return [DEFAULT_CAR_PASS_MILEAGE_ISSUE_KEY];
  }

  const messageKeys = [...issues.hardErrors, ...issues.notifications]
    .map((code) => MILEAGE_ISSUE_KEY_BY_CODE.get(code))
    .filter(isNotNil);

  const uniqueKeys = [...new Set(messageKeys)];

  return uniqueKeys.length > 0 ? uniqueKeys : [DEFAULT_CAR_PASS_MILEAGE_ISSUE_KEY];
}
